import HourglassEmptyOutlined from "@mui/icons-material/HourglassEmptyOutlined"
import { useState } from "react"
import { Position } from "reactflow"

import CustomHandle from "../../CustomHandle"
import { getEditorData } from "../../utils"
import BaseNode, { GreenNodeLabel, NodeContentLayout } from "../BaseNode"
import TimeDelayNodeEditor from "./Editor"

export default function TimeDelayNode(node) {
  const [editorOpen, setEditorOpen] = useState(false)

  const data = getEditorData(node)

  return (
    <>
      <BaseNode node={node} rootProps={{ onClick: () => setEditorOpen(true) }}>
        <CustomHandle
          id="top-handle"
          type="target"
          position={Position.Top}
          node={node}
        />
        <GreenNodeLabel label="Action" />
        <NodeContentLayout
          title={node.data.label}
          subtitle={`${data.days} days, ${data.hours} hours, ${data.minutes} minutes`}
          Icon={HourglassEmptyOutlined}
        />
        <CustomHandle
          id="bottom-handle"
          type="source"
          position={Position.Bottom}
          node={node}
        />
      </BaseNode>
      <TimeDelayNodeEditor
        open={editorOpen}
        onClose={() => setEditorOpen(false)}
        node={node}
      />
    </>
  )
}
